import React from 'react';
import {injectIntl} from "react-intl";
import withAuthorization from "../../../services/Authorization";
import CarParkTable from "./CarParkTable";

class CarParkManagement extends React.Component {

  render() {
    const {intl:{formatMessage}} = this.props;

    return (
      <div>
        <header className="main-header">
          <div className="main-header__left">
            <h1 className="main__title">
              {formatMessage({id:'section.car-park-management.title'})}
            </h1>
          </div>
        </header>

        <div className="main__content">
          <CarParkTable/>
        </div>
      </div>
    )
  }
}

export default withAuthorization(injectIntl(CarParkManagement), ['DUI_ADMIN', 'DUI_SERVICE_ADVISOR']);
